// extracted by mini-css-extract-plugin
module.exports = {"save-button":"save-button_save-button__nJxWn","disabled":"save-button_disabled__3t8MR"};